<template>
    <div v-show="!loading">

        <div class="counterBase">
            <div class="mb-2 grey--text text--lighten-1">{{title}}</div>
            <v-icon v-if="prefixIcon" class="mb-1 mr-2" color="grey lighten-1" :size="iconSize">{{prefixIcon}}</v-icon>
            <flip-number :size="size" v-if="prefix!==null" :value="prefix"></flip-number>
            <flip-number :size="size" v-for="(number,index) in numbers" :key="Math.random()" :value="number"></flip-number>
            <flip-number :size="size" v-for="(number,index) in postfixLetters" :key="index" :value="number"></flip-number>
            <v-icon v-if="postfixIcon" class="mb-1 ml-1" color="grey lighten-1" :size="iconSize">{{postfixIcon}}</v-icon>
        </div>

    </div>
</template>

<script>

    import FlipNumber from './FlipNumber';

    export default {

        components: {
            FlipNumber,
        },

        props: {

            value: {
                type: Number | String,
                required: true
            },

            prefix: {
                type: String | null,
                required: false,
                default: null,
            },

            prefixIcon: {
                type: String,
                required: false,
            },

            postfix: {
                type: String,
                required: false,
            },

            postfixIcon: {
                type: String,
                required: false,
            },

            title: {
                type: String,
                require: false,
            },

            loading: {
                type: Boolean,
                required: false,
                default: false
            },

            digits: {
                type: Number,
                required: false,
                default: null
            },

            size: {
                type: String,
                required: false,
                validator: value => {
                    return ['small', 'medium', 'large'].includes(value);
                },
                default: 'small',
            }
        },
        data() {
            return {
                numbers: [],
                postfixLetters: [],
            }
        },

        computed: {

            currentCount() {
                return this.value;
            },

            iconSize() {
                switch (this.size) {
                    case 'small':
                        return '25px';
                    case 'medium':
                        return '40px';
                    case 'large':
                        return '60px';
                }
            }
        },

        watch: {
            value(value) {
                this.parseDigits();
            },
        },

        methods: {

            parseDigits() {
                let digitString = '';

                if (typeof this.currentCount === 'NULL') return false;

                digitString = this.currentCount.toString();

                this.numbers = [];

                // Zero pad if requested
                if (this.digits) {
                    if (digitString.length < this.digits) {

                        for (let i=0; i < this.digits - digitString.length;i++) {
                            this.numbers.push(0);
                        }
                    }
                }

                for (let index = 0; index < digitString.length; index++) {

                    if (['.',',','%','$','€','£'].includes(digitString[index])) {
                        this.numbers.push(digitString[index]);
                    } else {
                        this.numbers.push(Number.parseInt(digitString[index]));
                    }
                }

                let postfixString = '';

                if (this.postfix) {
                    postfixString = this.postfix.toString();
                    for (let index = 0; index < postfixString.length; index++) {
                        this.numbers.push(postfixString[index]);
                    }
                }
            }
        },

        mounted() {
            this.parseDigits();
        },
    }
</script>

<style scoped>
    .counterBase {
        width: 100%;
        display: inline-block;
        text-align: center;
    }
</style>